import axios from 'axios'
import { useAuthStore } from '@/features/auth/stores/AuthStore'

const axiosInstance = axios.create({
  baseURL: process.env.VUE_APP_BASE_URL,
  timeout: 50000,
  headers: { 'Content-Type': 'application/json' }
})

// ✅ Interceptor — agrega el token en cada request
axiosInstance.interceptors.request.use(
  (config) => {
    const authStore = useAuthStore()
    if (authStore.token && !config.headers.Authorization) {
      config.headers.Authorization = `Bearer ${authStore.token}`
    }
    return config
  },
  (error) => Promise.reject(error)
)

export default axiosInstance